<div class="nav" [ngClass]="{'colap' : !menuColap}">
  <div class="sideMenu">
    <div class="headMenu">
      <button class="burgerBtn" (click)="menuColap = !menuColap">
        <span class="barBgr"></span>
        <span class="barBgr"></span>
        <span class="barBgr"></span>
      </button>

      <div class="logo">
        <img src="assets/img/logo.svg">
      </div>
    </div>

    <div class="secProfile" (click)="showModalPerfil()">
      <div class="profileCirle" >
        {{usuario?.given_name.charAt(0)}}{{usuario?.family_name.charAt(0)}}
      </div>
      <p>VER PERFIL</p>
    </div>


    <div class="menuSection">
      <ul class="navMenu">
        <li class="navItem" routerLinkActive="active" *ngIf="tienePermisoJornada()">
          <a class="navLink"  routerLink="/admin/gestion-jornada">
            <span class="ico">
              <img src="assets/img/icoGJ.svg">
              <img class="active" src="assets/img/icoGJa.svg">
            </span>
            <span class="label">GESTIÓN DE <br>JORNADA</span>

          </a>
        </li>

        <li class="navItem" routerLinkActive="active" *ngIf="tienePermisoConductores()">
          <a class="navLink"  routerLink="/admin/gestion-conductores">
            <span class="ico">
              <img src="assets/img/icoGC.svg">
              <img class="active" src="assets/img/icoGCa.svg">
            </span>
            <span class="label">GESTIÓN DE <br>CONDUCTORES</span>
          </a>
        </li>

        <li class="navItem" routerLinkActive="active" *ngIf="tienePermisoDespachador()">
          <a class="navLink" routerLink="/admin/despachador">
            <span class="ico">
              <img src="assets/img/icoD.svg">
              <img class="active" src="assets/img/icoDa.svg">
            </span>
            <span class="label">DESPACHADOR</span>
          </a>
        </li>

        <li class="navItem" routerLinkActive="active" *ngIf="tienePermisoSinoptico()">
          <a class="navLink" routerLink="/admin/sinoptico">
            <span class="ico">
              <img src="assets/img/icoS.svg">
              <img class="active" src="assets/img/icoSa.svg">
            </span>
            <span class="label">SINÓPTICO</span>
          </a>
        </li>

        <li class="navItem" routerLinkActive="active" *ngIf="tienePermisoGestionBuses()">
          <a class="navLink" routerLink="/admin/gestion-buses">
            <span class="ico">
              <img src="assets/img/icoGB.svg">
              <img class="active" src="assets/img/icoGBa.svg">
            </span>
            <span class="label">GESTIÓN DE <br>BUSES</span>
          </a>
        </li>

        <li class="navItem" routerLinkActive="active" *ngIf="permisoImportador">
          <a class="navLink" routerLink="/admin/importador">
            <span class="ico">
              <img src="assets/img/icoI.svg">
              <img class="active" src="assets/img/icoIa.svg">
            </span>
            <span class="label">IMPORTADOR</span>
          </a>
        </li>

      </ul>
    </div>


    <div class="sucursales">

      <div class="ico">
        <img src="assets/img/icoSucursal.svg" >
      </div>

      <div class="label">
        <span>SUCURSALES:</span>
        {{cantidadSucursalesSeleccionadas}} SELECCIONADA{{cantidadSucursalesSeleccionadas === 1 ? '' : 'S'}}
      </div>

    </div>

    <div class="git-version">
      <span style="font-weight: bold;" *ngIf="envName == 'qa'">AMBIENTE QA</span>
      <span>{{gitV}}</span>
      <span>{{gitH}}</span>
    </div>

  </div>



  <div class="main">
    <div class="container-fluid">
      <router-outlet/>
    </div>
  </div>

</div>



